"use client";

import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function VantaBackground() {
  const vantaRef = useRef(null);
  const vantaEffect = useRef(null); // 🎯 fix اصلی

  useEffect(() => {
    let isMounted = true;

    const initVanta = async () => {
      if (!vantaRef.current) return;

      const THREE = await import("three");
      const VANTA = await import("vanta/dist/vanta.fog.min");

      if (isMounted && !vantaEffect.current) {
        vantaEffect.current = VANTA.default({
          el: vantaRef.current,
          THREE: THREE,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.0,
          minWidth: 200.0,
          highlightColor: 0x19b0ff,
          midtoneColor: 0x6436fa,
          lowlightColor: 0x3d8cf7,
          baseColor: 0xf0f8ff,
          speed: 1.4,
        });
      }
    };

    initVanta();

    return () => {
      isMounted = false;
      if (vantaEffect.current) {
        vantaEffect.current.destroy();
        vantaEffect.current = null;
      }
    };
  }, []);

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 1.5,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const [t] = useTranslation("global");

  return (
    <>
      {/* <div className="w-full h-[70vh] absolute top-[100vh] bg-gradient-to-t to-transparent -translate-y-full left-0 from-[#040f1a] -z-[1]" /> */}
      <div className="relative z-20 flex flex-col items-center justify-center  lg:px-4 lg:py-20 px-4 pt-4 text-center pb-[80px] overflow-hidden">
        <div
          ref={vantaRef}
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: -1,
          }}
          className="opacity-80 lg:opacity-90 top-0 left-0"
        />
        {/* کانتینر اصلی محتوا: شامل متن و تصویر بنر */}
        <div className="relative w-full max-w-7xl flex flex-col md:flex-row items-center justify-between p-2 lg:p-8">
          {/* محتوای متنی (سمت چپ) */}
          <motion.div
            className="flex flex-col  items-center lg:items-start text-left md:w-1/2 w-full mb-14 md:mb-0 z-30 relative"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <motion.h1
              className="text-5xl md:text-7xl lg:text-8xl font-extrabold mb-4 drop-shadow-lg"
              variants={itemVariants}
            >
              {t("homepage.title")}
            </motion.h1>

            <motion.p
              className="text-lg md:text-xl lg:text-2xl mb-1 drop-shadow-md text-black"
              variants={itemVariants}
            >
              {t("homepage.subtitle")}
            </motion.p>

            <motion.p
              className="text-lg md:text-xl lg:text-2xl mb-2 drop-shadow-md text-black"
              variants={itemVariants}
            >
              {t("homepage.description")}
            </motion.p>

            <motion.a
              href="tel:+971501926568"
              whileHover={{
                scale: 1.1,
                color: "#FFD700",
                textShadow: "0px 0px 8px rgba(255, 215, 0, 0.8)",
              }}
              variants={itemVariants}
              transition={{ type: "spring", stiffness: 300 }}
              className="mt-2 font-bold cursor-pointer inline-block"
            >
              📞 {t("homepage.callNow")} +971 50 192 6568
            </motion.a>
          </motion.div>

          <motion.div
            animate={{
              y: [0, -10, 0], // بالا و پایین
              rotateZ: [0, 1, -1, 0], // چرخش خفیف
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="md:w-1/2 w-full"
          >
            <motion.div
              animate={{ rotate: -360 }}
              transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
              className="absolute bg-purple-500 blur-[80px] rounded-[30px] w-[90%] h-[90%] -translate-x-1/2 left-[10%] top-[10%] -translate-y-1/2 -z-10"
            />
            <motion.img
              src="/mobile.png"
              className="w-full"
              alt="Mobile epskan"
              initial={{
                y: 300,
                rotateX: 60,
                rotateY: -60,
                opacity: 0,
                scale: 0.8,
              }}
              animate={{
                y: 0,
                rotateX: 0,
                rotateY: 0,
                opacity: 1,
                scale: 1,
              }}
              transition={{
                duration: 1.8,
                ease: "easeOut",
                type: "spring",
                stiffness: 100,
                damping: 20,
                delay: 1.8,
              }}
            />
          </motion.div>
        </div>
      </div>
    </>
  );
}
